if (typeof VideoPopup !== "function") {
  class VideoPopup extends HTMLElement {
    constructor() {
      super();

      const container = this.querySelector(".video-popup__container");
      const pauseIcon = this.querySelector(".video-popup__pause");
      const playIcon = this.querySelector(".video-popup__play");
      const overlay = this.querySelector(".video-overlay");
      const video_block = this.querySelector('video');

      container.addEventListener("mouseenter", (e) => {
        const media = this.closest("[data-video]");
        media.style = "cursor: pointer;";
      });

      container.addEventListener("click", (e) => {
        const media = this.closest("[data-video]");   
        const videoElement = media.querySelector("video");
        if (videoElement) {
          if (this.classList.contains("video-playing")) {
            this._pauseMedia(media);
            overlay.style.display = "block";
            this.classList.remove("video-playing");
          } else {
            this._playMedia(media);
            overlay.style.display = "none";
            this.classList.add("video-playing");
          }
        }
      });

      if (!video_block) {
        this.querySelector("[data-js-video-popup-container]").appendChild(
          this.querySelector (
            "template"
          ).content.firstElementChild.cloneNode(true)
        );
      } 

      const videoElement = document.querySelector("video");
      if (videoElement) {
        videoElement.muted = true;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const media = this.closest("[data-video]"); 
      
          if (entry.isIntersecting) {
            setTimeout(() => {
              this._playMedia(media);
              this.classList.add("video-playing");
            }, 100);
          } else {
            this._pauseMedia(media);
            this.classList.remove("video-playing");
          }
        });
      }, { 
        threshold: 0.1,
        rootMargin: '50px'
      });
      
      observer.observe(this);
      


      this.querySelector("[data-js-video-popup-link]").addEventListener(
        "click",
        (e) => {
          e.preventDefault();

          this.classList.add("video-opened");
          this.classList.add("video-playing");

          setTimeout(() => {
            this.querySelector("[data-js-video-popup-container]").appendChild(
              this.querySelector (
                "template"
              ).content.firstElementChild.cloneNode(true)
            );
            setTimeout(() => {
              this._playMedia(this.closest("[data-video]"));
            }, 500);
          }, 50);
        }
      );
    }

    _playMedia(media) {
      switch (media.dataset.productMediaType) {
        case "video":
          const videoElement = media.querySelector("video");
          if (videoElement) {
            videoElement.loop = true;
            videoElement.muted = true;
            videoElement.play().catch(error => {
              console.log('Autoplay prevented:', error);
              this.classList.remove("video-playing");
            });
          }
          break;
        case "external_video-youtube":
          const youtubeIframe = media.querySelector(".js-youtube");
          if (youtubeIframe) {
            youtubeIframe.contentWindow.postMessage(
              '{"event":"command","func":"' + "playVideo" + '","args":""}',
              "*"
            );
          }
          break;
        case "external_video-vimeo":
          const vimeoIframe = media.querySelector(".js-vimeo");
          if (vimeoIframe) {
            vimeoIframe.contentWindow.postMessage('{"method":"play"}', "*");
          }
          break;
      }
    }

    _pauseMedia(media) {
      switch (media.dataset.productMediaType) {
        case "video":
          if (media.querySelector("video")) {
            media.querySelector("video").pause();
          }
          break;
        case "external_video-youtube":
          if (media.querySelector(".js-youtube")) {
            media
              .querySelector(".js-youtube")
              .contentWindow.postMessage(
                '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
                "*"
              );
          }
          break;
        case "external_video-vimeo":
          if (media.querySelector(".js-vimeo")) {
            media
              .querySelector(".js-vimeo")
              .contentWindow.postMessage('{"method":"pause"}', "*");
          }
          break;
      }
    }
  }

  if (typeof customElements.get("video-popup") == "undefined") {
    customElements.define("video-popup", VideoPopup);
  }
}